import Breadcrumb from "./Breadcrumb.vue";
import { pluginify } from "./../../util";
export default pluginify(Breadcrumb);
export { Breadcrumb };
